import React from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link } from "react-router-dom";

const Kitview = () => {
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid py-4">
                <div className="card shadow border-0 p-4">
                  {/* Header Title & Button */}
                  <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                   <div className="col-md-3">
                    <h4 className="mb-0">
                      Kit: <span className="text-primary">hoodi</span>
                    </h4>

                   </div>
                   <div className="col-md-9 text-end">
                    <Link to={"/kits/transaction"}>
                    <button
                      className="btn btn-primary  px-4 mx-2"
                      // onClick={() => (window.location.href = "/kits/view")}
                    >
                      + Kit Transaction
                    </button></Link>
                  
                    <Link className="btn btn-danger" to={'/kits'}> Back</Link>
                     
                   
                   </div>
                  </div>

                  {/* Filters */}
                  <div className="row g-3 mb-4">
                    <div className="col-md-3">
                      <label className="form-label fw-semibold">Batch</label>
                      <select className="form-select">
                        <option>All Batch</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label fw-semibold">
                        Filter Session
                      </label>
                      <select className="form-select">
                        <option>2024-2025</option>
                      </select>
                    </div>
                    <div className="col-md-3 d-flex align-items-end gap-2">
                      <button className="btn btn-primary w-100">Filter</button>
                      <button className="btn btn-danger w-100">Reset</button>
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive">
                    <table className="table table-hover table-bordered text-center align-middle">
                      <thead className="">
                        <tr>
                          <th>#</th>
                          <th>Student Name</th>
                          <th>Mobile No.</th>
                          <th>Batch</th>
                          <th>Quantity</th>
                          <th>Remark</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="  fw-bold">1</td>
                          <td className="fw-bold">DEVRAJ SHARMA (3303)</td>
                          <td>9</td>
                          <td>a</td>
                          <td>1</td>
                          <td>–</td>
                          <td>23-Apr-2025</td>
                        </tr>
                        <tr>
                          <td className="fw-bold">2</td>
                          <td className=" fw-bold">PURVI CHOUDHARY (3407)</td>
                          <td>8058334924</td>
                          <td>a</td>
                          <td>1</td>
                          <td>–</td>
                          <td>23-Apr-2025</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
};

export default Kitview;
